"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const styles = (theme) => ({
    clrFieldIcon: Object.assign({ border: 'solid', borderWidth: '2px', borderColor: theme.palette.border.dark, borderRadius: theme.shape.borderRadius * 6, width: '24px', height: '24px', textAlign: 'center', marginLeft: 'auto', marginRight: 'auto', paddingLeft: 1 }, transactionsConfig_1.clrFieldOptions.styles(theme)),
    clrFieldText: Object.assign({ borderRadius: theme.shape.borderRadius * 6, padding: `2px ${theme.shape.padding[4]}px`, textAlign: 'center', marginLeft: 'auto', marginRight: 'auto' }, transactionsConfig_1.clrFieldOptions.styles(theme)),
    iconFont: {
        fontSize: '13px',
        borderRadius: theme.spacing.borderRadius * 6,
        lineHeight: '21px',
    },
    iconText: Object.assign({ fontSize: '14px', borderRadius: '23px', lineHeight: '21px', background: 'unset' }, transactionsConfig_1.clrFieldOptions.styles(theme)),
});
exports.styles = styles;
